import React from 'react'

export default function Footer() {
  return (
    <footer className='footer'>
      <span>Desenvolvido por Bruno Melo.</span>
    </footer>
  )
}
